module.exports = __webpack_public_path__ + "static/media/culvers_chicago_22_3.a81234ee.png";